<section class="ierc-section">

  <h2 class="titulo-principal">Rendición de Cuentas (IERC)</h2>

  <p class="subinfo">
    ITESCARCEGA – Rendición de Cuentas (IERC) – Última actualización: 19 Abril 2026 
  </p>

  <h3 class="titulo-secundario">
    INFORMES DE RENDICIÓN DE CUENTAS (2020 - 2024)
  </h3>

  <p class="descripcion">
    Listado cronológico de los informes institucionales para consulta pública:
  </p>

  <ul class="lista-pdf">

    <li>
      <img src="assets/vinculacion/pdf.png">
      <a href="assets/rendicion_cuentas/ITSE-IRC-2025.pdf" target="_blank">
        <strong>2025:</strong> Informe de Rendición de Cuentas
      </a>
    </li>

    <li>
      <img src="assets/vinculacion/pdf.png">
      <a href="assets/rendicion_cuentas/ITSE-IRC-2024.pdf" target="_blank">
        <strong>2024:</strong> Informe de Rendición de Cuentas
      </a>
    </li>

    <li>
      <img src="assets/vinculacion/pdf.png">
      <a href="assets/rendicion_cuentas/ITSE-IRC-2023.pdf" target="_blank">
        <strong>2023:</strong> Informe de Rendición de Cuentas
      </a>
    </li>

    <li>
      <img src="assets/vinculacion/pdf.png">
      <a href="assets/rendicion_cuentas/ITSE-IRC-2022.pdf" target="_blank">
        <strong>2022:</strong> Informe de Rendición de Cuentas
      </a>
    </li>

    <li>
      <img src="assets/vinculacion/pdf.png">
      <a href="assets/rendicion_cuentas/ITSE-IRC-2021.pdf" target="_blank">
        <strong>2021:</strong> Informe de Rendición de Cuentas
      </a>
    </li>

    <li>
      <img src="assets/vinculacion/pdf.png">
      <a href="assets/rendicion_cuentas/ITSE-IRC-2020.pdf" target="_blank">
        <strong>2020:</strong> Informe de Rendición de Cuentas
      </a>
    </li>

  </ul>

</section>